import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Button, Alert } from "react-bootstrap";
import axiosOrganizationInstance from "./AxiosOrganizationInstance";
import FloatingLabelInput from "../restaurant/PlaceHolder";
import styles from "./css/school-signin.module.css";  // Import CSS Module for scoped styles
import logo from "./assets/junior-eats-logo.png";
import bike from "./assets/bike.png";
import restaurant from "./assets/Restaurant.png";
import children from "./assets/children.png";
import { UserContext } from "../context/UserContext";


const OrganizationLogin = ({ onLogin }) => {
  const {setUser} = useContext(UserContext)
  const [role, setRole] = useState("ADMIN");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      let response;
      if (role === "ADMIN") {
        response = await axiosOrganizationInstance.post("/admin-login", {
          email,
          password,
        });
        console.log('1',response.data)
        const { organizationId, userId,contactNumber,organizationName } = response.data.organization;
        if ( userId) {
          localStorage.setItem("organizationId", JSON.stringify(organizationId));
          localStorage.setItem("userId", JSON.stringify(userId));
          localStorage.setItem("organizationName", organizationName);
        }
        onLogin(contactNumber); // Notify parent about successful login
      } else {
        response = await axiosOrganizationInstance.post("/user-login", {
          contact_number: mobileNumber,
          password,
        });

        const { organizationId, user_id,contact_number,organization_name } = response.data.organization_user;
        if (user_id) {
          localStorage.setItem("user_id", user_id);
        }
        if (organizationId) {
          localStorage.setItem("organizationId", organizationId); // Save organizationId for Employee
        }
        onLogin(user_id, organization_name, contact_number); // Notify parent about successful login
      }

      // Store the token in localStorage
      localStorage.setItem("Token", response.headers.get("X-Auth-Token"));

      // Navigate based on the role
      if (role === "ADMIN") {
        navigate("/organization/dashboard");
      } else {
        navigate("/organization/employee");
      }
    } catch (error) {
      console.error("Login failed:", error);
      setError("Invalid credentials. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      {/* Left section: Background and visuals */}
      <div className={styles.leftSection}>
        <div className={styles.imageGroup}>
          <img src={bike} alt="bike" className={styles.bike} />
          <img
            src={restaurant}
            alt="Restaurant"
            className={styles.restaurant}
          />
         
          <img
            src={children}
            alt="Children Eating"
            className={styles.children}
          />
           
        </div>
      </div>

      {/* Right section: Login form */}
      <div className={styles.rightSection}>
        <img src={logo} alt="Junior Eats Logo" className={styles.logo} />
        <div className={styles.register_form}>
          <Form onSubmit={handleLogin}>
            <h2 style={{ marginBottom: "20px" }}>Organization</h2>

            {/* Role Selection */}
            <Form.Group style={{ marginBottom: "20px" }}>
              <Form.Check
                type="radio"
                label="&nbsp;&nbsp;Admin"
                
                name="role"
                value="ADMIN"
                checked={role === "ADMIN"}
                onChange={() => setRole("ADMIN")}
                inline
              />
              <Form.Check
                type="radio"
                label="&nbsp;&nbsp;Employee"
                name="role"
                value="Employee"
                checked={role === "Employee"}
                onChange={() => setRole("Employee")}
                inline
              />
            </Form.Group>

            {error && (
              <Alert variant="danger" style={{ marginBottom: "20px" }}>
                {error}
              </Alert>
            )}

            {role === "ADMIN" ? (
              <>
                <FloatingLabelInput
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  label="Enter your email"
                  isRequired={true}
                />
                <br />
                {/* Show Forgot Password only for ADMIN */}
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    textAlign: "right",
                    marginTop: "-20px",
                  }}
                >
                  <a
                    className={styles.forgotPassword}
                    style={{ float: "right", fontSize: "12px" }}
                    href="/organization/forgotpassword"
                  >
                    Forgot Password
                  </a>
                </div>
              </>
            ) : (
              <>
                <FloatingLabelInput
                  type="text"
                  value={mobileNumber}
                  onChange={(e) => setMobileNumber(e.target.value)}
                  label="Enter your mobile number"
                  isRequired={true}
                />
              </>
            )}

            <br></br>
            <FloatingLabelInput
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              label="Enter Password"
              isRequired={true}
            />
            <br></br>

            <Button type="submit" disabled={loading} className={styles.button1}>
              Sign In
            </Button>
            <br />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <p style={{ marginTop: "14px" }}>Don't have an account? </p>
              <a
                href="/organization/signup"
                style={{
                  textDecoration: "none",
                  fontSize: "14px",
                  fontWeight: "bold",
                  marginLeft: '15px'
                }}
              >
                Sign Up
              </a>

              <a href="https://jreats.com/" className="signup_link" style={{ fontWeight: "bold", marginLeft: '15px' }}>Home</a>
              
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default OrganizationLogin;
